'use client';
import { NavbarBrand, Navbar, NavbarItem, NavbarContent } from '@heroui/react';
import Image from 'next/image';
import React, { useState } from 'react';
import MobileNavbarMenu from './mobile-navbar-menu';
import { useTranslations } from 'next-intl';
import { Links } from '../utils/links';
import { useCustomizationContext } from '../customizations-provider';
import useCustomerStore from '../store/use-customer-store';

type NavigationBarProps = {
  links: Links;
};
export default function NavigationBar({ links }: NavigationBarProps) {
  const t = useTranslations('navigation');
  const tLinks = useTranslations('links');
  const c = useCustomizationContext();
  const logo = c('customer.logo');
  const isGreensCustomer = useCustomerStore((state) => state.isGreensCustomer);
  const logoLink = isGreensCustomer ? links.greens : tLinks('logo');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Navbar
      data-testid="navbar"
      onMenuOpenChange={setIsMenuOpen}
      shouldHideOnScroll
      maxWidth="full"
      classNames={{
        base: 'h-[90px]',
        wrapper: 'lg:px-24',
      }}
      className="bg-[var(--color-navigation-main)]"
    >
      <NavbarBrand className="flex basis-auto">
        <a data-testid="navigation-logo" href={logoLink}>
          <Image
            data-testid="navbar-logo"
            src={logo.url}
            alt={logo.description}
            width={logo.width}
            height={logo.height}
            className="flex-1 h-10 w-auto"
            priority
          />
        </a>
      </NavbarBrand>
      <NavbarContent justify="end">
        <NavbarItem>
          <a
            data-testid="navbar-login-button"
            href={links.appLogin}
            className="btn-primary btn-padded-responsive text-nowrap"
          >
            {t('login')}
          </a>
        </NavbarItem>
        {isGreensCustomer && (
          <MobileNavbarMenu isMenuOpen={isMenuOpen} links={links} />
        )}
      </NavbarContent>
    </Navbar>
  );
}
